//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Bepaalt de overdrachtsbelasting percentage op basis van de gegeven input.
     * @param body (optional) Input nodig voor de bepaling
     * @return Success
     */
    overdrachtsbelastingPercentage(body: OverdrachtsbelastingPercentageInput | null | undefined): Promise<OverdrachtsbelastingPercentageOutput> {
        let url_ = this.baseUrl + "/Bepalingen/OverdrachtsbelastingPercentage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOverdrachtsbelastingPercentage(_response);
        });
    }

    protected processOverdrachtsbelastingPercentage(response: Response): Promise<OverdrachtsbelastingPercentageOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverdrachtsbelastingPercentageOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverdrachtsbelastingPercentageOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverdrachtsbelastingPercentageOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverdrachtsbelastingPercentageOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverdrachtsbelastingPercentageOutput>(null as any);
    }

    /**
     * Berekent het eigenwoningforfait op basis van de gegeven input.
     * @param body (optional) Input nodig voor de berekening
     * @return Success
     */
    eigenwoningforfait(body: EigenwoningforfaitInput | null | undefined): Promise<EigenwoningforfaitOutput> {
        let url_ = this.baseUrl + "/Berekeningen/Eigenwoningforfait";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEigenwoningforfait(_response);
        });
    }

    protected processEigenwoningforfait(response: Response): Promise<EigenwoningforfaitOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EigenwoningforfaitOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EigenwoningforfaitOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EigenwoningforfaitOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EigenwoningforfaitOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EigenwoningforfaitOutput>(null as any);
    }

    /**
     * Bepaalt de AOW Franchise op basis van de gegeven input.
     * @param body (optional) Input nodig voor de bepaling
     * @return Success
     */
    aOW_Franchise(body: AowFranchiseInput | null | undefined): Promise<AowFranchiseOutput> {
        let url_ = this.baseUrl + "/Berekeningen/AowFranchise";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAOW_Franchise(_response);
        });
    }

    protected processAOW_Franchise(response: Response): Promise<AowFranchiseOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AowFranchiseOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AowFranchiseOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AowFranchiseOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AowFranchiseOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AowFranchiseOutput>(null as any);
    }

    /**
     * Geeft de beschikbare jaren met bijbehorende maand van beschikbare fiscale tarieven.
     * @return Success
     */
    beschikbare_fiscale_tarieven_ophalen(): Promise<JaarMaand[]> {
        let url_ = this.baseUrl + "/api/Fiscaal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBeschikbare_fiscale_tarieven_ophalen(_response);
        });
    }

    protected processBeschikbare_fiscale_tarieven_ophalen(response: Response): Promise<JaarMaand[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JaarMaand[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JaarMaand[]>(null as any);
    }

    /**
     * Geeft de fiscale tarieven van het gegeven jaar en maand.
     * @param jaar Het gewenste jaar
     * @param maand De gewenste maand in het jaar
     * @return Success
     */
    fiscale_tarieven_ophalen(jaar: number, maand: number): Promise<Algemeen> {
        let url_ = this.baseUrl + "/api/Fiscaal/{jaar}/{maand}";
        if (jaar === undefined || jaar === null)
            throw new Error("The parameter 'jaar' must be defined.");
        url_ = url_.replace("{jaar}", encodeURIComponent("" + jaar));
        if (maand === undefined || maand === null)
            throw new Error("The parameter 'maand' must be defined.");
        url_ = url_.replace("{maand}", encodeURIComponent("" + maand));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFiscale_tarieven_ophalen(_response);
        });
    }

    protected processFiscale_tarieven_ophalen(response: Response): Promise<Algemeen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Algemeen;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Algemeen>(null as any);
    }

    /**
     * Geeft de notaristarieven.
     * @return Success
     */
    tarieven_voor_notarissen_ophalen(): Promise<Notaristarief[]> {
        let url_ = this.baseUrl + "/Tarieven/Notarissen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTarieven_voor_notarissen_ophalen(_response);
        });
    }

    protected processTarieven_voor_notarissen_ophalen(response: Response): Promise<Notaristarief[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Notaristarief[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notaristarief[]>(null as any);
    }

    /**
     * Geeft de makelaarscourtagetarieven.
     * @return Success
     */
    tarieven_voor_makelaars_ophalen(): Promise<Courtagetarief[]> {
        let url_ = this.baseUrl + "/Tarieven/Makelaars";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTarieven_voor_makelaars_ophalen(_response);
        });
    }

    protected processTarieven_voor_makelaars_ophalen(response: Response): Promise<Courtagetarief[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Courtagetarief[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Courtagetarief[]>(null as any);
    }

    /**
     * Geeft de tarieven voor de overdracht erfpacht.
     * @return Success
     */
    tarieven_voor_overdracht_erfpacht_ophalen(): Promise<OverdrachtErfpachtTarief[]> {
        let url_ = this.baseUrl + "/Tarieven/OverdrachtErfpacht";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTarieven_voor_overdracht_erfpacht_ophalen(_response);
        });
    }

    protected processTarieven_voor_overdracht_erfpacht_ophalen(response: Response): Promise<OverdrachtErfpachtTarief[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OverdrachtErfpachtTarief[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OverdrachtErfpachtTarief[]>(null as any);
    }

    /**
     * Geeft de taxatietarieven.
     * @return Success
     */
    tarieven_voor_taxaties_ophalen(): Promise<Taxatietarief[]> {
        let url_ = this.baseUrl + "/Tarieven/Taxaties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTarieven_voor_taxaties_ophalen(_response);
        });
    }

    protected processTarieven_voor_taxaties_ophalen(response: Response): Promise<Taxatietarief[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Taxatietarief[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Taxatietarief[]>(null as any);
    }

    /**
     * Geeft de kredietnormen.
     * @return Success
     */
    tarieven_voor_kredietnormen_ophalen(): Promise<Kredietnorm[]> {
        let url_ = this.baseUrl + "/Tarieven/Kredietnormen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTarieven_voor_kredietnormen_ophalen(_response);
        });
    }

    protected processTarieven_voor_kredietnormen_ophalen(response: Response): Promise<Kredietnorm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Kredietnorm[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Kredietnorm[]>(null as any);
    }

    /**
     * Geeft de beschikbare jaren met bijbehorende maand van beschikbare toetsing tarieven.
     * @return Success
     */
    beschikbare_tarieven_voor_toetsing_ophalen(): Promise<JaarMaand[]> {
        let url_ = this.baseUrl + "/api/Toetsing";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBeschikbare_tarieven_voor_toetsing_ophalen(_response);
        });
    }

    protected processBeschikbare_tarieven_voor_toetsing_ophalen(response: Response): Promise<JaarMaand[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JaarMaand[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JaarMaand[]>(null as any);
    }

    /**
     * Geeft de toetsing tarieven van het gegeven jaar en maand.
     * @return Success
     */
    tarieven_voor_toetsing_ophalen(jaar: number, maand: number): Promise<Toetsing> {
        let url_ = this.baseUrl + "/api/Toetsing/{jaar}/{maand}";
        if (jaar === undefined || jaar === null)
            throw new Error("The parameter 'jaar' must be defined.");
        url_ = url_.replace("{jaar}", encodeURIComponent("" + jaar));
        if (maand === undefined || maand === null)
            throw new Error("The parameter 'maand' must be defined.");
        url_ = url_.replace("{maand}", encodeURIComponent("" + maand));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTarieven_voor_toetsing_ophalen(_response);
        });
    }

    protected processTarieven_voor_toetsing_ophalen(response: Response): Promise<Toetsing> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Toetsing;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Toetsing>(null as any);
    }

    /**
     * Geeft de laatste 1 of 2 toetsnormen.
     * @return Success
     */
    toetsnormen_ophalen(): Promise<Toetsnorm[]> {
        let url_ = this.baseUrl + "/api/Toetsing/toetsnormen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processToetsnormen_ophalen(_response);
        });
    }

    protected processToetsnormen_ophalen(response: Response): Promise<Toetsnorm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Toetsnorm[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Toetsnorm[]>(null as any);
    }

    /**
     * Geeft versie informatie van de applicatie.
     * @return De gevraagde versieinfo kon worden opgehaald en is beschikbaar in de uitvoer.
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Er is iets foutgegaan tijdens het ophalen van de versieinfo. Kijken in de Messages van de uitvoer voor het probleem.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }
}

/** AfrondingLeefnormOptions Onbekend = 0, _2Decimalen = 1, _NaarBoven = 2 */
export enum AfrondingLeefnormOptions {
    Onbekend = "Onbekend",
    _2Decimalen = "_2Decimalen",
    _NaarBoven = "_NaarBoven",
}

export interface Algemeen {
    algemeenId: string;
    sociaal: Sociaal | null;
    fiscaal: Fiscaal | null;
    kindgebondenBudget: KindgebondenBudget | null;
    kinderbijslagen: Kinderbijslag[] | null;
    financiering: Financiering | null;
    jaar: number | null;
    maand: number | null;
}

export interface AlgemeneHeffingskorting {
    algemeneHeffingskortingId: string;
    bedragVoorAow: number | null;
    bedragAow: number | null;
    bedragAfbouwVanafVoorAow: number | null;
    bedragAfbouwVanafAow: number | null;
    percentageAfbouwVanafVoorAow: number | null;
    percentageAfbouwVanafAow: number | null;
    bedragMaxAfbouwVoorAow: number | null;
    bedragMaxAfbouwAow: number | null;
    datumAfbouwVanaf: string | null;
    aantalJarenAfbouw: number | null;
    heffingskorting: Heffingskorting | null;
    heffingskortingId: string | null;
}

/** Invoer voor de AOW Franchise-berekening. */
export interface AowFranchiseInput {
    soortPensioenregeling: Pensioenregelingsoort;
    burgerlijkeStaat: BurgerlijkeStaatType;
    tarievenNorm: TarievenNorm | null;
}

/** Het resultaat van de AOW Franchise-berekening. */
export interface AowFranchiseOutput {
    /** De bepaalde AOW Franchise. */
    aowFranchiseBedrag: number | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Arbeidskorting {
    arbeidskortingId: string;
    bedragMinInkomen: number | null;
    percentageLaagVoorAow: number | null;
    percentageLaagAow: number | null;
    percentageHoogVoorAow: number | null;
    percentageHoogAow: number | null;
    bedragVoorAow: number | null;
    bedragAow: number | null;
    bedragGrens: number | null;
    percentageGrensVoorAow: number | null;
    percentageGrensAow: number | null;
    bedragMinderingVoorAow: number | null;
    bedragMinderingAow: number | null;
    heffingskorting: Heffingskorting | null;
    heffingskortingId: string | null;
}

export interface ArbeidskortingV2 {
    arbeidskortingId: string;
    aow: boolean | null;
    bedragInkomenVan: number | null;
    bedragInkomenTotMet: number | null;
    bedragBasis: number | null;
    percentageKorting: number | null;
    bedragAfslag: number | null;
    heffingskorting: Heffingskorting | null;
    heffingskortingId: string | null;
}

export interface BadRequestResult {
    statusCode: number;
}

export interface Belastingschijf {
    belastingschijfId: string;
    bedragOndergrens: number | null;
    bedragBovengrens: number | null;
    percentageActief: number | null;
    percentageInactief: number | null;
    box1: Box1 | null;
    box1Id: string | null;
    box2: Box2 | null;
    box2Id: string | null;
}

export interface BeperkingInkomen {
    beperkingInkomenId: string;
    maatschappijCode: string | null;
    arrangementnummer: number | null;
    inkomensOnderdeel: InkomensOnderdeelOptions | null;
    soortBeperking: BeperkingInkomenOptions | null;
    percentageMaxMeetellen: number | null;
    percentageMeetellen: number | null;
    ghf: Ghf | null;
    ghfId: string | null;
}

/** BeperkingInkomenOptions Geen = 0, VastInkomen = 1, TotaalInkomen = 2, KaalInkomen = 3 */
export enum BeperkingInkomenOptions {
    Geen = "Geen",
    VastInkomen = "VastInkomen",
    TotaalInkomen = "TotaalInkomen",
    KaalInkomen = "KaalInkomen",
}

export interface Box1 {
    box1Id: string;
    percentageMkbWinstvrijstelling: number | null;
    readonly aantalJarenAfbouwHypotheekrenteaftrek: number | null;
    jaarAfbouwHypotheekrenteaftrek: number | null;
    percentageAfbouwHypotheekrenteaftrekTot: number | null;
    percentageAfbouwHypotheekrenteaftrek: number | null;
    percentageAfbouwHypotheekrenteaftrekVanaf: number | null;
    bedragZelfstandigenaftrek: number | null;
    bedragMaxForDotatie: number | null;
    percentageForDotatie: number | null;
    jaarAfbouwNihilSchuldAftrek: number | null;
    percentageAfbouwNihilSchuldAftrek: number | null;
    jaarAfbouwVersneldHypRenteAftrek: number | null;
    percentageAfbouwVersneldHypRenteAftrek: number | null;
    jaarAfbouwHypRenteaftrekEinde: number | null;
    belastingschijven: Belastingschijf[] | null;
    meewerkaftrekken: Meewerkaftrek[] | null;
    jaarruimte: Jaarruimte | null;
    zelfstandigenaftrek: Zelfstandigenaftrek | null;
    fiscaal: Fiscaal | null;
    fiscaalId: string | null;
}

export interface Box2 {
    box2Id: string;
    belastingschijven: Belastingschijf[] | null;
    fiscaal: Fiscaal | null;
    fiscaalId: string | null;
}

export interface Box3 {
    box3Id: string;
    bedragVermogensvrijeVoet: number | null;
    bedragMaxGrondslag: number | null;
    percentageForfaitairRendement: number | null;
    bedragVrijstellingKapitaal: number | null;
    percentageBelasting: number | null;
    percentageForfaitairRendementSpaar: number | null;
    percentageForfaitairRendementBelegging: number | null;
    percentageForfaitairRendementSchulden: number | null;
    forfaitairRendementschijven: ForfaitairRendementSchijf[] | null;
    fiscaal: Fiscaal | null;
    fiscaalId: string | null;
}

/** BurgerlijkeStaatType Geen = 0, GehuwdGemeenschapVanGoederen = 1, GehuwdMetHuwelijkseVoorwaarden = 2, Alleenstaand = 3, SamenwonendMetSamenlevingscontract = 4, SamenwonendZonderSamenlevingscontract = 5, PartnerregistratieInGemeenschapVanGoederen = 6, PartnerregistratieOnderRegistratievoorwaarden = 7, GehuwdVolgensBuitenlandsRecht = 8, GehuwdInBeperkteGemeenschapVanGoederen = 9, PartnerregistratieInBeperkteGemeenschapVanGoederen = 10 */
export enum BurgerlijkeStaatType {
    Geen = "Geen",
    GehuwdGemeenschapVanGoederen = "GehuwdGemeenschapVanGoederen",
    GehuwdMetHuwelijkseVoorwaarden = "GehuwdMetHuwelijkseVoorwaarden",
    Alleenstaand = "Alleenstaand",
    SamenwonendMetSamenlevingscontract = "SamenwonendMetSamenlevingscontract",
    SamenwonendZonderSamenlevingscontract = "SamenwonendZonderSamenlevingscontract",
    PartnerregistratieInGemeenschapVanGoederen = "PartnerregistratieInGemeenschapVanGoederen",
    PartnerregistratieOnderRegistratievoorwaarden = "PartnerregistratieOnderRegistratievoorwaarden",
    GehuwdVolgensBuitenlandsRecht = "GehuwdVolgensBuitenlandsRecht",
    GehuwdInBeperkteGemeenschapVanGoederen = "GehuwdInBeperkteGemeenschapVanGoederen",
    PartnerregistratieInBeperkteGemeenschapVanGoederen = "PartnerregistratieInBeperkteGemeenschapVanGoederen",
}

export interface Courtagetarief {
    drempelbedrag: number | null;
    franchisebedrag: number | null;
    vastBedrag: number | null;
    percentage: number | null;
    minimumbedrag: number | null;
}

/** DienstVerbandType Geen = 0, LoondienstFulltimeVast = 1, LoondienstFulltimeTijdelijkPlusIntentieverklaring = 2, LoondienstParttimeVast = 3, LoondienstParttimeTijdelijkPlusIntentieverklaring = 4, Zelfstandig = 5, Wia = 6, Student = 7, VutPensioenLijfrente = 8, WwWachtgeldRww = 9, HuisvrouwHuisman = 10, GeenBeroep = 11, Onbekend = 12, DirecteurGrootaandeelhouder_Dga = 13, LoondienstFulltimeTijdelijkZonderIntentieverklaring = 14, LoondienstParttimeTijdelijkZonderIntentieverklaring = 15, Seizoensarbeider = 17, AnwErfrente = 18, ZelfstandigNv = 19, ZonderInkomensbescheiden = 20, ZelfstandigeZonderPersoneel_Zzp_ = 21, ZelfstandigeMetPersoneel = 22, VutPrepensioen = 23, Pensioen = 24, Lijfrente = 25, Bijstand = 26 */
export enum DienstVerbandType {
    Geen = "Geen",
    LoondienstFulltimeVast = "LoondienstFulltimeVast",
    LoondienstFulltimeTijdelijkPlusIntentieverklaring = "LoondienstFulltimeTijdelijkPlusIntentieverklaring",
    LoondienstParttimeVast = "LoondienstParttimeVast",
    LoondienstParttimeTijdelijkPlusIntentieverklaring = "LoondienstParttimeTijdelijkPlusIntentieverklaring",
    Zelfstandig = "Zelfstandig",
    Wia = "Wia",
    Student = "Student",
    VutPensioenLijfrente = "VutPensioenLijfrente",
    WwWachtgeldRww = "WwWachtgeldRww",
    HuisvrouwHuisman = "HuisvrouwHuisman",
    GeenBeroep = "GeenBeroep",
    Onbekend = "Onbekend",
    DirecteurGrootaandeelhouder_Dga = "DirecteurGrootaandeelhouder_Dga",
    LoondienstFulltimeTijdelijkZonderIntentieverklaring = "LoondienstFulltimeTijdelijkZonderIntentieverklaring",
    LoondienstParttimeTijdelijkZonderIntentieverklaring = "LoondienstParttimeTijdelijkZonderIntentieverklaring",
    Seizoensarbeider = "Seizoensarbeider",
    AnwErfrente = "AnwErfrente",
    ZelfstandigNv = "ZelfstandigNv",
    ZonderInkomensbescheiden = "ZonderInkomensbescheiden",
    ZelfstandigeZonderPersoneel_Zzp_ = "ZelfstandigeZonderPersoneel_Zzp_",
    ZelfstandigeMetPersoneel = "ZelfstandigeMetPersoneel",
    VutPrepensioen = "VutPrepensioen",
    Pensioen = "Pensioen",
    Lijfrente = "Lijfrente",
    Bijstand = "Bijstand",
}

/** Invoer voor de eigenwoningforfait-berekening. */
export interface EigenwoningforfaitInput {
    /** WOZ-waarde waarover het eigenwoningforfait berekend moet worden. */
    wozWaarde: number;
    tarievenNorm: TarievenNorm | null;
}

/** Het resultaat van de eigenwoningforfait-berekening. */
export interface EigenwoningforfaitOutput {
    /** Het berekende eigenwoningforfait. */
    eigenwoningforfait: number | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface Financiering {
    kadastraalRechtMetBedrag: number | null;
    kadastraalRechtZonderBedrag: number | null;
    geheelPerceel: number | null;
    gedeeldPerceel: number | null;
    registratierecht: number | null;
    kortingHypotheekAkte: number | null;
    percentageOverdrachtsbelasting: number | null;
    percentageOverdrachtsbelastingStarters: number | null;
    percentageOverdrachtsbelastingBeleggers: number | null;
    bedragOverdrachtsbelastingVrijstellingStarters: number | null;
    algemeenId: string;
    algemeen: Algemeen | null;
}

export interface Fiscaal {
    fiscaalId: string;
    box1: Box1 | null;
    box2: Box2 | null;
    box3: Box3 | null;
    heffingskorting: Heffingskorting | null;
    zvw: Zvw | null;
    algemeen: Algemeen | null;
    algemeenId: string | null;
    huurwaardes: Huurwaardes | null;
}

export interface ForfaitairRendementSchijf {
    forfaitairRendementSchijfId: string;
    bedragOndergrens: number;
    bedragBovengrens: number | null;
    percentage: number;
    box3: Box3 | null;
    box3Id: string | null;
}

/** GebruikPandSoort Geen = 0, PrimaireWoning = 1, TweedeWoning = 2, DeelsVerhuurd = 3, GeheelVerhuurd = 4 */
export enum GebruikPandSoort {
    Geen = "Geen",
    PrimaireWoning = "PrimaireWoning",
    TweedeWoning = "TweedeWoning",
    DeelsVerhuurd = "DeelsVerhuurd",
    GeheelVerhuurd = "GeheelVerhuurd",
}

/** GemiddeldResultaatOpties Geen = 0, Gemiddelde = 1, _3xJaar1_2xJaar2_1xJaar3 = 2, _3xJaar1_2xJaar2_1xJaar3_90 = 3 */
export enum GemiddeldResultaatOpties {
    Geen = "Geen",
    Gemiddelde = "Gemiddelde",
    _3xJaar1_2xJaar2_1xJaar3 = "_3xJaar1_2xJaar2_1xJaar3",
    _3xJaar1_2xJaar2_1xJaar3_90 = "_3xJaar1_2xJaar2_1xJaar3_90",
}

export interface Ghf {
    ghfId: string;
    percentageMarktwaarde: number | null;
    percentageMarktwaardeEbv: number | null;
    percentageOpslagWoonquoteTweeverdieners: number | null;
    toetsinkomens: Toetsinkomen[] | null;
    beperkingen: BeperkingInkomen[] | null;
    toetsInfos: ToetsInfo[] | null;
    onderpandNormen: OnderpandNorm[] | null;
    krediettoetsingen: Krediettoetsing[] | null;
    toetsing: Toetsing | null;
    toetsingId: string | null;
}

export interface Heffingskorting {
    heffingskortingId: string;
    algemeneHeffingskorting: AlgemeneHeffingskorting | null;
    arbeidskorting: Arbeidskorting | null;
    inkomensafhankelijkeCombinatiekorting: InkomensafhankelijkeCombinatiekorting | null;
    ouderenkorting: Ouderenkorting | null;
    werkbonus: Werkbonus | null;
    ouderenToeslagen: OuderenToeslag[] | null;
    bedragAlleenstaandeouderenkorting: number | null;
    arbeidskortingen: ArbeidskortingV2[] | null;
    fiscaal: Fiscaal | null;
    fiscaalId: string | null;
}

export interface HuurwaardeSchijf {
    huurwaardeSchijfId: string;
    bedragOndergrens: number;
    basisbedrag: number;
    percentage: number;
    huurwaardes: Huurwaardes | null;
    huurdwaardesId: string | null;
}

export interface Huurwaardes {
    huurwaardesId: string;
    huurwaardeSchijven: HuurwaardeSchijf[] | null;
    fiscaal: Fiscaal | null;
    fiscaalId: string | null;
}

/** InkomensOnderdeelOptions Geen = 0, Overwerk = 1, BuitenlandsInkomen = 2, _13eMaand = 3, Gratificatie = 4, Onregelmatigheidstoeslag = 5, InkomstenToeslag = 6, Veb = 7, Provisie = 8, SomProvisieOnregelmatigheidstoeslagOverwerk = 9 */
export enum InkomensOnderdeelOptions {
    Geen = "Geen",
    Overwerk = "Overwerk",
    BuitenlandsInkomen = "BuitenlandsInkomen",
    _13eMaand = "_13eMaand",
    Gratificatie = "Gratificatie",
    Onregelmatigheidstoeslag = "Onregelmatigheidstoeslag",
    InkomstenToeslag = "InkomstenToeslag",
    Veb = "Veb",
    Provisie = "Provisie",
    SomProvisieOnregelmatigheidstoeslagOverwerk = "SomProvisieOnregelmatigheidstoeslagOverwerk",
}

export interface InkomensafhankelijkeCombinatiekorting {
    inkomensafhankelijkeCombinatiekortingId: string;
    bedragMinInkomen: number;
    bedragVoorAow: number;
    bedragAow: number;
    bedragMaxVoorAow: number;
    bedragMaxAow: number;
    percentageVoorAow: number;
    percentageAow: number;
    heffingskorting: Heffingskorting | null;
    heffingskortingId: string | null;
}

/** InkomensvormOptions Geen = 0, InkomenUitArbeid = 1, WinstUitOnderneming = 2, OverigeWerkzaamheden = 3, OntvangenAlimentatie = 4, AnwUitkering = 5, WiaUitkering = 6, WwUitkering = 7, OverigeUitkering = 8, InkomstenVerhuur = 9, InkomstenUitBeleggingen = 10, OverigePosten = 11, LijfrenteUitkering = 12, NabestaandenpensioenVoorAow = 13, NabestaandenpensioenNaAow = 14, WajongUitkering = 15, AowUitkering = 16, Wachtgeld = 17, Rww = 18, Waz = 19, Wga = 20, Iva = 21, WaoTijdelijk = 22, WaoBlijvend = 23, PensioenUitkering = 24 */
export enum InkomensvormOptions {
    Geen = "Geen",
    InkomenUitArbeid = "InkomenUitArbeid",
    WinstUitOnderneming = "WinstUitOnderneming",
    OverigeWerkzaamheden = "OverigeWerkzaamheden",
    OntvangenAlimentatie = "OntvangenAlimentatie",
    AnwUitkering = "AnwUitkering",
    WiaUitkering = "WiaUitkering",
    WwUitkering = "WwUitkering",
    OverigeUitkering = "OverigeUitkering",
    InkomstenVerhuur = "InkomstenVerhuur",
    InkomstenUitBeleggingen = "InkomstenUitBeleggingen",
    OverigePosten = "OverigePosten",
    LijfrenteUitkering = "LijfrenteUitkering",
    NabestaandenpensioenVoorAow = "NabestaandenpensioenVoorAow",
    NabestaandenpensioenNaAow = "NabestaandenpensioenNaAow",
    WajongUitkering = "WajongUitkering",
    AowUitkering = "AowUitkering",
    Wachtgeld = "Wachtgeld",
    Rww = "Rww",
    Waz = "Waz",
    Wga = "Wga",
    Iva = "Iva",
    WaoTijdelijk = "WaoTijdelijk",
    WaoBlijvend = "WaoBlijvend",
    PensioenUitkering = "PensioenUitkering",
}

export interface JaarMaand {
    jaar: number;
    maand: number;
}

export interface Jaarruimte {
    jaarruimteId: string;
    bedragMaxPremiegrondslag: number | null;
    bedragFranchise: number | null;
    percentagePensioenaangroei: number | null;
    percentagePremiegrondslag: number | null;
    box1: Box1 | null;
    box1Id: string | null;
}

export interface Kinderbijslag {
    kinderbijslagId: string;
    aantalKinderen: number | null;
    bedragTm5Jaar: number | null;
    bedragTm11Jaar: number | null;
    bedragTm17Jaar: number | null;
    algemeen: Algemeen | null;
    algemeenId: string | null;
}

export interface KindgebondenBudget {
    kindgebondenBudgetId: string;
    bedragKind1: number | null;
    bedragKind2: number | null;
    bedragKind3: number | null;
    bedragKind4: number | null;
    bedrag12Tm15Jaar: number | null;
    bedrag16Tm17Jaar: number | null;
    bedragOuderkop: number | null;
    bedragGrens: number | null;
    percentageGrens: number | null;
    algemeen: Algemeen | null;
    algemeenId: string | null;
}

/** KredietToetsmethodeOptions Geen = 0, Tm2PcOKredietsom = 1, TmHoogste2PcOKredietsomEnWL = 2, TmLaagste2PcOKredietsomEnWL = 3, TmWLof2PcOKredietsom = 4, TmOKredietsomLooptijd = 5, TmHoogste2PcOKredietsomEnLooptijd = 6, Tm2PcKredietlimiet = 7, TmHoogste2PcKredietlimietEnWL = 8, Tm075Of045PcWetStudievoorschot = 9, TmBrutoWL = 10, TmNettoWL = 11, Tm075PcOKredietsom = 12, TmHoogste1PcOKredietlimietEnWL = 13, Tm65Pc2PcMaandlastLooptijd = 14, TmHoogsteWetStudievoorschotEnWL = 15 */
export enum KredietToetsmethodeOptions {
    Geen = "Geen",
    Tm2PcOKredietsom = "Tm2PcOKredietsom",
    TmHoogste2PcOKredietsomEnWL = "TmHoogste2PcOKredietsomEnWL",
    TmLaagste2PcOKredietsomEnWL = "TmLaagste2PcOKredietsomEnWL",
    TmWLof2PcOKredietsom = "TmWLof2PcOKredietsom",
    TmOKredietsomLooptijd = "TmOKredietsomLooptijd",
    TmHoogste2PcOKredietsomEnLooptijd = "TmHoogste2PcOKredietsomEnLooptijd",
    Tm2PcKredietlimiet = "Tm2PcKredietlimiet",
    TmHoogste2PcKredietlimietEnWL = "TmHoogste2PcKredietlimietEnWL",
    Tm075Of045PcWetStudievoorschot = "Tm075Of045PcWetStudievoorschot",
    TmBrutoWL = "TmBrutoWL",
    TmNettoWL = "TmNettoWL",
    Tm075PcOKredietsom = "Tm075PcOKredietsom",
    TmHoogste1PcOKredietlimietEnWL = "TmHoogste1PcOKredietlimietEnWL",
    Tm65Pc2PcMaandlastLooptijd = "Tm65Pc2PcMaandlastLooptijd",
    TmHoogsteWetStudievoorschotEnWL = "TmHoogsteWetStudievoorschotEnWL",
}

export interface Kredietgrens {
    kredietgrensId: string;
    productcode: number;
    bedragMaximum: number | null;
    bedragMinimum: number | null;
}

export interface Kredietnorm {
    kredietnormId: string;
    maatschappijCode: string | null;
    percentageOverwerkMeetellen: number | null;
    tijdelijkDienstverbandMeenemen: TijdelijkDienstverbandMeenemenOptions | null;
    ondernemingMeetellen: boolean | null;
    wiaUitkeringMeenemen: WiaUitkeringMeenemenOptions | null;
    percentageWiaUitkering: number | null;
    koopwoningMinimaalBasishuur: boolean | null;
    bedragHuurlastMinimaal: number | null;
    afrondingLeefnorm: AfrondingLeefnormOptions | null;
    percentageWgaUitkering: number | null;
    percentageIvaUitkering: number | null;
    percentageWazUitkering: number | null;
    kredietgrenzen: Kredietgrens[] | null;
}

export interface Krediettoetsing {
    krediettoetsingId: string;
    maatschappijCode: string | null;
    arrangementnummer: number | null;
    kredietvorm: KredietvormOptions;
    toetsmethode: KredietToetsmethodeOptions;
    toetsmethodeNhg: KredietToetsmethodeOptions | null;
    ghf: Ghf | null;
    ghfId: string | null;
}

/** KredietvormOptions Geen = 0, AflopendKrediet = 1, DoorlopendKrediet = 2, Studielening = 3, RestschuldMetNhg = 4, RestschuldZonderNhg = 5, PrivateLease = 6 */
export enum KredietvormOptions {
    Geen = "Geen",
    AflopendKrediet = "AflopendKrediet",
    DoorlopendKrediet = "DoorlopendKrediet",
    Studielening = "Studielening",
    RestschuldMetNhg = "RestschuldMetNhg",
    RestschuldZonderNhg = "RestschuldZonderNhg",
    PrivateLease = "PrivateLease",
}

export interface Meewerkaftrek {
    meewerkaftrekId: string;
    aantalUren: number | null;
    percentageAftrek: number | null;
    box1: Box1 | null;
    box1Id: string | null;
}

export interface Nhg {
    nhgId: string;
    bedragKostengrens: number | null;
    bedragKostengrensEbv: number | null;
    bedragKostengrensOversluiten: number | null;
    percentageBorgtochtprovisie: number | null;
    percentageOpslagBestaandeBouw: number | null;
    percentageOpslagBestaandeBouwEbv: number | null;
    percentageOpslagNieuwbouw: number | null;
    percentageOpslagNieuwbouwEbv: number | null;
    percentageMaxAflossingsvrij: number | null;
    bedragVrijstellingEbv: number | null;
    bedragVrijstellingEbvEnergieNeutraal: number | null;
    bedragVrijstellingEbvNulOpDeMeter: number | null;
    bedragMinInkomenVrijstellingEbv: number | null;
    percentageOpslagWoonquote: number | null;
    bedragMinInkomenOpslagWoonquote: number | null;
    bedragMaxInkomenOpslagWoonquote: number | null;
    percentageKoopsomVrijOpNaam: number | null;
    percentageBijkomendeKosten: number | null;
    percentageMaandlastStudielening15Jaar: number | null;
    percentageMaandlastStudielening35Jaar: number | null;
    teBetalenAlimentatieAchteraf: boolean | null;
    woonquotesBox1VoorAow: WoonquoteBox1VoorAow[] | null;
    woonquotesBox1Aow: WoonquoteBox1Aow[] | null;
    woonquotesBox3VoorAow: WoonquoteBox3VoorAow[] | null;
    woonquotesBox3Aow: WoonquoteBox3Aow[] | null;
    opslagenStartersRenteregelingen: OpslagStartersRenteregeling[] | null;
    studieleningToetslasten: StudieleningToetslast[] | null;
    toetsing: Toetsing | null;
    toetsingId: string | null;
}

export interface Notaristarief {
    drempelbedrag: number | null;
    transportakteMinimum: number | null;
    transportakteMaximum: number | null;
    bedragHypotheekinschrijving: number | null;
}

export interface OnderpandNorm {
    onderpandNormId: string;
    maatschappijCode: string | null;
    arrangementnummer: number | null;
    soortNorm: OnderpandNormOptions | null;
    percentageNorm: number | null;
    percentageNormAlternatief: number | null;
    percentageNormRestschuld: number | null;
    codeBepalingMarktwaardeNieuwbouw: number | null;
    nhgVolgend: boolean | null;
    percentageNormRestschuldAlternatief: number | null;
    percentageMaxRenteverlies: number | null;
    ghf: Ghf | null;
    ghfId: string | null;
}

/** OnderpandNormOptions Geen = 0, Executiewaarde = 1, Marktwaarde = 2, ExecutiewaardeObvOndernemer = 3, ExecutiewaardeObvPostcode = 4, ExecutiewaardeObvAov = 5, MarktwaardeobvOnderpand = 6, ExecutiewaardeObvAankoop = 7, MarktwaardeObvWinst = 8, Overig = 99 */
export enum OnderpandNormOptions {
    Geen = "Geen",
    Executiewaarde = "Executiewaarde",
    Marktwaarde = "Marktwaarde",
    ExecutiewaardeObvOndernemer = "ExecutiewaardeObvOndernemer",
    ExecutiewaardeObvPostcode = "ExecutiewaardeObvPostcode",
    ExecutiewaardeObvAov = "ExecutiewaardeObvAov",
    MarktwaardeobvOnderpand = "MarktwaardeobvOnderpand",
    ExecutiewaardeObvAankoop = "ExecutiewaardeObvAankoop",
    MarktwaardeObvWinst = "MarktwaardeObvWinst",
    Overig = "Overig",
}

export interface OpslagStartersRenteregeling {
    opslagStartersRenteregelingId: string;
    percentageRenteVanaf: number | null;
    bedragInkomenVanaf: number | null;
    factorMaximaleHypotheek: number | null;
    nhg: Nhg | null;
    nhgId: string | null;
}

export interface OuderenToeslag {
    ouderenToeslagId: string;
    aantalInkomens: number | null;
    bedragInkomen1Box1Vanaf: number | null;
    bedragInkomen1Box1Tot: number | null;
    bedragInkomen2Box1Vanaf: number | null;
    bedragInkomen2Box1Tot: number | null;
    percentageToeslag: number | null;
    bedragMaxToeslag: number | null;
    heffingskorting: Heffingskorting | null;
    heffingskortingId: string | null;
}

export interface Ouderenkorting {
    ouderenkortingId: string;
    bedragMaxInkomen: number | null;
    bedragBovenMaxInkomen: number | null;
    bedragTotMaxInkomen: number | null;
    percentageAfbouw: number | null;
    heffingskorting: Heffingskorting | null;
    heffingskortingId: string | null;
}

export interface OverdrachtErfpachtTarief {
    drempelwaarde: number | null;
    factor: number | null;
}

export interface OverdrachtsbelastingPercentageAanvrager {
    geboortedatum: string | null;
    eigendomPercentage: number | null;
}

/** Invoer voor de overdrachtsbelasting percentage bepaling. */
export interface OverdrachtsbelastingPercentageInput {
    aanvrager1: OverdrachtsbelastingPercentageAanvrager | null;
    aanvrager2: OverdrachtsbelastingPercentageAanvrager | null;
    /** Koopsom van de woning */
    koopsomBedrag: number | null;
    gebruikPand: GebruikPandSoort | null;
    /** Passeerdatum van de hypotheek */
    passeerDatum: string | null;
    tarievenNorm: TarievenNorm | null;
}

/** Het resultaat van de eigenwoningforfait-berekening. */
export interface OverdrachtsbelastingPercentageOutput {
    /** Het berekende eigenwoningforfait. */
    overdrachtsbelastingPercentage: number | null;
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Pensioenregelingsoort Geen = 0, Eindloon = 1, Middelloon = 2, BeschikbarePremie = 3 */
export enum Pensioenregelingsoort {
    Geen = "Geen",
    Eindloon = "Eindloon",
    Middelloon = "Middelloon",
    BeschikbarePremie = "BeschikbarePremie",
}

export interface Sociaal {
    sociaalId: string;
    aowBedragOngehuwdPerJaar: number | null;
    aowBedragGehuwdPerJaar: number | null;
    wia: Wia | null;
    anwBedragPerMaand: number | null;
    ww: Ww | null;
    bedragMinLoonPerJaar: number | null;
    aantalDagenSvwUitkering: number | null;
    bedragMaxSvwDagInkomen: number | null;
    readonly bedragMaxSvwJaarinkomen: number | null;
    aowFranchiseBedragMiddelloonregelingGehuwd: number | null;
    aowFranchiseBedragMiddelloonregelingOngehuwd: number | null;
    aowFranchiseBedragEindloonGehuwd: number | null;
    aowFranchiseBedragEindloonOngehuwd: number | null;
    eindloonOpbouwMaxPercentage: number | null;
    middelloonOpbouwMaxPercentage: number | null;
    algemeen: Algemeen | null;
    algemeenId: string | null;
}

export interface StudieleningToetslast {
    studieleningToetslastId: string;
    percentageRenteVanaf: number | null;
    percentageRenteTot: number | null;
    percentageMaandlastStudielening15Jaar: number | null;
    percentageMaandlastStudielening35Jaar: number | null;
    nhg: Nhg | null;
    nhgId: string | null;
}

export interface TarievenNorm {
    jaar: number;
    maand: number;
}

export interface Taxatietarief {
    drempelbedrag: number | null;
    franchisebedrag: number | null;
    vastBedrag: number | null;
    percentage: number | null;
    minimumbedrag: number | null;
}

/** TijdelijkDienstverbandMeenemenOptions Onbekend = 0, _70Procent = 1, _70ProcentJonger30OfGeenEigenWoning = 2 */
export enum TijdelijkDienstverbandMeenemenOptions {
    Onbekend = "Onbekend",
    _70Procent = "_70Procent",
    _70ProcentJonger30OfGeenEigenWoning = "_70ProcentJonger30OfGeenEigenWoning",
}

export interface ToetsInfo {
    toetsinfoId: string;
    maatschappijCode: string | null;
    arrangementnummer: number | null;
    erfpachtAchteraf: boolean | null;
    teBetalenAlimentatieAchteraf: boolean | null;
    vermogenAchteraf: boolean | null;
    percentageVermogenMeetellen: number | null;
    bedragMinKredietsom: number | null;
    woonquoteTweeverdieners: boolean | null;
    bedragMinInkomenWoonquoteTweeverdieners: number | null;
    bedragAdministratiekosten: number | null;
    werkelijkeLooptijd: boolean | null;
    opslagWoonquote: boolean | null;
    opgebouwdeWaardeMeetellen: boolean | null;
    box3Oversluiten: boolean | null;
    soortGemiddeldResultaat: GemiddeldResultaatOpties | null;
    uwvVerklaring: boolean | null;
    perspectiefverklaring: boolean | null;
    werkgeversverklaring: boolean | null;
    accountantverklaringNhg: boolean | null;
    accountantverklaringGhf: boolean | null;
    arbeidsmarktscanNhg: boolean | null;
    arbeidsmarktscanGhf: boolean | null;
    toetsingAflossingsvrijBox3: boolean | null;
    ghf: Ghf | null;
    ghfId: string | null;
    ebv: boolean | null;
    ebb: boolean | null;
}

export interface Toetsing {
    toetsingId: string;
    percentageStaatsrente: number | null;
    nhg: Nhg | null;
    ghf: Ghf | null;
    jaar: number | null;
    maand: number | null;
}

export interface Toetsinkomen {
    toetsinkomenId: string;
    maatschappijCode: string | null;
    arrangementnummer: number | null;
    inkomensvorm: InkomensvormOptions | null;
    dienstverband: DienstVerbandType | null;
    percentageMeetellen: number;
    ghf: Ghf | null;
    ghfId: string | null;
}

export interface Toetsnorm {
    jaar: number;
    maand: number;
    omschrijving: string | null;
    code: number;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export interface Werkbonus {
    werkbonusId: string;
    bedragWerkbonus: number | null;
    bedragWerkbonusGrens1: number | null;
    bedragWerkbonusGrens2: number | null;
    percentageWerkbonusGrens1: number | null;
    percentageWerkbonusGrens2: number | null;
    heffingskorting: Heffingskorting | null;
    heffingskortingId: string | null;
}

export interface WgaAanvullend {
    wgaAanvullendId: string;
    aoPercentageVanaf: number | null;
    percentageUitkering: number | null;
    wia: Wia | null;
    wiaId: string | null;
}

export interface Wia {
    wiaId: string;
    percentageIvaUitkering: number | null;
    percentageWgaUitkering2mnd: number | null;
    percentageWgaUitkeringNa2mnd: number | null;
    wgaAanvullendUitkeringen: WgaAanvullend[] | null;
    sociaal: Sociaal | null;
    sociaalId: string | null;
}

/** WiaUitkeringMeenemenOptions Onbekend = 0, _70Procent = 1, _100ProcentIndienVoor19540701 = 2 */
export enum WiaUitkeringMeenemenOptions {
    Onbekend = "Onbekend",
    _70Procent = "_70Procent",
    _100ProcentIndienVoor19540701 = "_100ProcentIndienVoor19540701",
}

export interface WoonquoteBox1Aow {
    woonquoteId: string;
    percentageRenteVanaf: number | null;
    bedragInkomenVanaf: number | null;
    percentageFinLast: number | null;
    nhg: Nhg | null;
    nhgId: string | null;
}

export interface WoonquoteBox1VoorAow {
    woonquoteId: string;
    percentageRenteVanaf: number | null;
    bedragInkomenVanaf: number | null;
    percentageFinLast: number | null;
    nhg: Nhg | null;
    nhgId: string | null;
}

export interface WoonquoteBox3Aow {
    woonquoteId: string;
    percentageRenteVanaf: number | null;
    bedragInkomenVanaf: number | null;
    percentageFinLast: number | null;
    nhg: Nhg | null;
    nhgId: string | null;
}

export interface WoonquoteBox3VoorAow {
    woonquoteId: string;
    percentageRenteVanaf: number | null;
    bedragInkomenVanaf: number | null;
    percentageFinLast: number | null;
    nhg: Nhg | null;
    nhgId: string | null;
}

export interface Ww {
    wwId: string;
    aantalLoontijdvakDagen: number | null;
    bedragDagFranchise: number | null;
    percentageWerkgever: number | null;
    percentageWerknemer: number | null;
    sociaal: Sociaal | null;
    sociaalId: string | null;
}

export interface Zelfstandigenaftrek {
    aftrekBedrag: number;
    afbouwPerJaarBedrag: number;
    afbouwVanaf: number;
    afbouwTot: number;
    afbouwTotBedrag: number;
    zelfstandigenaftrekId: string;
    box1: Box1 | null;
}

export interface Zvw {
    zvwId: string;
    bedragMaxGrondslag: number | null;
    percentageWerknemer: number | null;
    fiscaal: Fiscaal | null;
    fiscaalId: string | null;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}